import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { SharedToastComponent } from '@shared-lib/components/toast/shared-toast.component';
import { FullstoryService } from '@shared-lib/services/fullstory.service';
import { MaintenanceService } from '@shared/services/maintenance.service';
import { setInitialPlatformType } from '@shared/store/platform/platform.actions';
import { take } from 'rxjs/operators';
import { AuthService } from './shared/services/auth.service';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'ap-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, SharedToastComponent],
})
export class AppComponent implements OnInit {
  private readonly globalStore = inject(Store);
  private readonly authService = inject(AuthService);
  private readonly themeService = inject(ThemeService);
  private readonly fullstoryService = inject(FullstoryService);
  private readonly maintenanceService = inject(MaintenanceService);

  ngOnInit(): void {
    this.fullstoryService.init();

    this.themeService.setTheme('theme-dashly');

    // Skip loading user data while the app is in maintenance mode
    this.maintenanceService
      .isMaintenanceModeEnabled()
      .pipe(take(1))
      .subscribe((maintenanceModeEnabled) => {
        if (maintenanceModeEnabled) return;

        if (!environment.production) {
          this.globalStore.dispatch(setInitialPlatformType());
        }
        this.authService.initAuthData();
      });
  }
}
